<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :filename="'guest_registration_card'"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="legal"
      pdf-orientation="portrait"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="container-fluid" v-if="selectedGuest !== null">
          <div class="mb-3">
            <div class="row">
              <div class="col-md-9">
                <div
                  class="d-flex align-items-start mb-2 text-dark"
                  v-if="hotel.email != '' || null"
                >
                  <i class="fas fa-envelope fs-5"></i>
                  <span class="mx-2">:</span>
                  <span>{{ hotel.email }}</span>
                </div>
                <div
                  class="d-flex align-items-start mb-2 text-dark"
                  v-if="hotel.front_desk_number !== '' || null"
                >
                  <i class="fas fa-phone-alt fs-5"></i>
                  <span class="mx-2">:</span>
                  <span>{{ hotel.front_desk_number }}</span>
                </div>
                <div
                  class="d-flex align-items-start mb-2 text-dark"
                  v-if="hotel.website != '' || null"
                >
                  <i class="dripicons-web lh-1 fs-5"></i>
                  <span class="mx-2">:</span>
                  <span>{{ hotel.website }}</span>
                </div>
                <div class="d-flex align-items-start mb-2 text-dark">
                  <i class="fas fa-map-marked-alt fs-5"></i>
                  <span class="mx-2">:</span>
                  <span>
                    {{
                      hotel.address !== "" || null ? hotel.address + "," : ""
                    }}
                    {{ hotel.city !== "" || null ? hotel.city + "," : "" }}
                    {{ hotel.state !== "" || null ? hotel.state + "," : "" }}
                    {{
                      hotel.country !== "" || null ? hotel.country + "," : ""
                    }}
                    {{ hotel.zip_code !== "" || null ? hotel.zip_code : "" }}
                  </span>
                </div>
              </div>
              <div class="col-md-3" v-if="hotel.logo !== '' || null">
                <img
                  :src="hotel.logo"
                  alt="hotel-logo"
                  class="card-hotel-logo ms-auto d-block"
                  @click="generateReport()"
                  crossorigin="Anonymous"
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-md-5">
                <h5 class="text-dark">
                  {{
                    selectedGuest.primary_guest.first_name
                      ? selectedGuest.primary_guest.first_name
                      : ""
                  }}
                  {{ selectedGuest.primary_guest.last_name }}
                </h5>
                <p class="text-dark mb-0">
                  {{
                    selectedGuest.primary_guest.address_line_first
                      ? selectedGuest.primary_guest.address_line_first
                      : ""
                  }}
                  {{
                    selectedGuest.primary_guest.address_line_second
                      ? selectedGuest.primary_guest.address_line_second + ", "
                      : ""
                  }}
                  {{
                    selectedGuest.primary_guest.city
                      ? selectedGuest.primary_guest.city + ", "
                      : ""
                  }}<br v-if="selectedGuest.primary_guest.city" />{{
                    selectedGuest.primary_guest.state
                      ? selectedGuest.primary_guest.state + ", "
                      : ""
                  }}<br v-if="selectedGuest.primary_guest.state" />{{
                    selectedGuest.primary_guest.country
                      ? selectedGuest.primary_guest.country + ", "
                      : ""
                  }}
                  {{
                    selectedGuest.primary_guest.zip_code
                      ? selectedGuest.primary_guest.zip_code
                      : ""
                  }}
                </p>
              </div>
              <div class="col-md-7">
                <div class="d-flex justify-content-end">
                  <div class="border-right px-3 text-center">
                    <h5 class="text-dark font-size-14">Booking Ref.</h5>
                    <p class="text-danger mb-0">
                      {{ selectedGuest.reference_no }}
                    </p>
                  </div>
                  <div class="border-right px-3 text-center">
                    <h5 class="text-dark font-size-14">PMS Ref.</h5>
                    <p class="text-danger mb-0">
                      {{
                        selectedGuest.booking_source_reference_no
                          ? selectedGuest.booking_source_reference_no
                          : "-"
                      }}
                    </p>
                  </div>
                  <div class="border-right px-3 text-center">
                    <h5 class="text-dark font-size-14">OTA Ref.</h5>
                    <p class="text-danger mb-0">
                      {{
                        selectedGuest.ota_reference_no
                          ? selectedGuest.ota_reference_no
                          : "-"
                      }}
                    </p>
                  </div>
                  <div class="px-3 text-center">
                    <h5 class="text-dark font-size-14">Source</h5>
                    <p class="text-danger mb-0">
                      {{
                        selectedGuest.booking_source.name
                          ? selectedGuest.booking_source.name
                          : "-"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="registration-box">
              <h6 class="mb-1">Room No.</h6>
              <span>{{
                selectedGuest.allotted_room
                  ? selectedGuest.allotted_room.room_number
                  : "-"
              }}</span>
            </div>
            <div class="registration-box">
              <div class="d-flex align-items-center">
                <i class="bx bx-calendar me-2 fs-4"></i>
                <div class="d-flex align-items-center">
                  <div>
                    <h6 class="mb-1">CheckIn</h6>
                    <span>{{ selectedGuest.check_in_date }}</span>
                  </div>
                  <div>
                    <div class="total-night bg-primary bg-soft">
                      <i class="fas fa-moon text-primary"></i>
                      <span class="font-weight-semibold ms-1 text-primary">{{
                        selectedGuest.stay_night
                      }}</span>
                    </div>
                  </div>
                  <div>
                    <h6 class="mb-1">CheckOut</h6>
                    <span>{{ selectedGuest.check_out_date }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="registration-box">
              <div class="d-flex align-items-center">
                <i class="bx bx-bed me-2 fs-4"></i>
                <div>
                  <h6 class="mb-1">Room Type</h6>
                  <span>{{ selectedGuest.room_type.name }}</span>
                </div>
              </div>
            </div>
            <div class="registration-box">
              <div class="d-flex align-items-center">
                <i class="bx bx-user me-2 fs-4"></i>
                <div>
                  <h6 class="mb-1">Rooms & Guests</h6>
                  <span
                    >{{ selectedGuest.total_room }} Room ,
                    {{ selectedGuest.total_adults }} Adults</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="registration-card-detail">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-dark">Description</th>
                  <th colspan="1"></th>
                  <th class="text-end text-dark">Charge</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in selectedGuest.transaction_box"
                  :key="index"
                >
                  <th class="text-dark">
                    {{ item.description }}
                  </th>
                  <td colspan="1"></td>
                  <td class="text-end">
                    {{ item.currency ? "$" : "₹" }}{{ item.debit }}
                  </td>
                </tr>

                <tr class="border-top-width">
                  <th></th>
                  <td>Sub Total</td>
                  <td class="text-end">
                    {{ selectedGuest.currency ? "$" : "₹"
                    }}{{ selectedGuest.current_balance }}
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>Tax</td>
                  <td class="text-end">
                    {{ selectedGuest.currency ? "$" : "₹" }}{{ "00.00" }}
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <td>Discount</td>
                  <td class="text-end">
                    {{ selectedGuest.currency ? "$" : "₹" }}{{ "00.00" }}
                  </td>
                </tr>
                <tr class="border-top-bottom-width">
                  <th></th>
                  <td class="fw-bold text-danger">GRAND TOTAL</td>
                  <td class="text-end">
                    {{ selectedGuest.currency ? "$" : "₹"
                    }}{{ selectedGuest.current_balance }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mb-3">
            <h5 class="dotted-border text-center text-dark pb-2 mb-3">
              Payment Details
            </h5>
            <div class="d-flex">
              <div class="w-50">
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">
                    Payment Type
                  </h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0 text-uppercase">
                    {{
                      selectedGuest.guest[0].credit_card.length !== 0
                        ? selectedGuest.guest[0].credit_card[0].card_brand
                        : "-"
                    }}
                  </p>
                </div>
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">Account</h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0">
                    {{
                      selectedGuest.guest[0].credit_card.length !== 0
                        ? "**** " +
                          selectedGuest.guest[0].credit_card[0].last_digit
                        : "-"
                    }}
                  </p>
                </div>
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">
                    Account Holder
                  </h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0">
                    {{
                      selectedGuest.guest[0].credit_card.length !== 0
                        ? selectedGuest.guest[0].credit_card[0].card_holder_name
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div>
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">
                    Amount Paid
                  </h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0">
                    {{ selectedGuest.currency ? "$" : "₹"
                    }}{{ selectedGuest.total_payment }}
                  </p>
                </div>
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">
                    Apporval Code
                  </h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0">{{ "-" }}</p>
                </div>
                <div class="d-flex mb-2">
                  <h5 class="font-size-14 min-w-130 text-dark mb-0">
                    Available Auth
                  </h5>
                  <span class="mx-2">:</span>
                  <p class="text-dark mb-0">
                    {{ selectedGuest.currency ? "$" : "₹"
                    }}{{ selectedGuest.current_balance }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <img
                v-if="selectedGuest.primary_guest.doc_image !== null"
                :src="selectedGuest.primary_guest.doc_image"
                alt="doc image"
                class="document-card-img rounded w-100 object-fit"
              />
              <img
                src="@/assets/images/placeholder-img.jpg"
                v-else
                class="document-card-img rounded w-100 object-fit"
              />
            </div>
            <div class="col-md-6">
              <div class="d-flex align-items-end mb-3">
                <p class="text-dark mt-40">
                  By signing here digital contract, I am agreeing with all Terms
                  & Condition of the hotel.
                </p>
                <div>
                  <img
                    v-if="selectedGuest.primary_guest.selfie_image"
                    :src="selectedGuest.primary_guest.selfie_image"
                    alt="selfie image"
                    class="selfie-card-img rounded object-fit"
                  />
                  <img
                    src="@/assets/images/placeholder-img.jpg"
                    v-else
                    class="selfie-card-img rounded object-fit"
                  />
                </div>
              </div>
              <div class="dashed-border rounded">
                <img
                  v-if="selectedGuest.contract_signature"
                  :src="selectedGuest.contract_signature"
                  alt="contract sign"
                  class="img-fluid"
                />
                <img
                  src="@/assets/images/signature-placeholder.png"
                  v-else
                  alt=""
                  class="d-block mx-auto my-2"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
    <div class="container-fluid" v-if="selectedGuest !== null">
      <div class="mb-3">
        <div class="row">
          <div class="col-md-9">
            <div
              class="d-flex align-items-start mb-2 text-dark"
              v-if="hotel.email != '' || null"
            >
              <i class="fas fa-envelope fs-5"></i>
              <span class="mx-2">:</span>
              <span>{{ hotel.email }}</span>
            </div>
            <div
              class="d-flex align-items-start mb-2 text-dark"
              v-if="hotel.front_desk_number !== '' || null"
            >
              <i class="fas fa-phone-alt fs-5"></i>
              <span class="mx-2">:</span>
              <span>{{ hotel.front_desk_number }}</span>
            </div>
            <div
              class="d-flex align-items-start mb-2 text-dark"
              v-if="hotel.website != '' || null"
            >
              <i class="dripicons-web lh-1 fs-5"></i>
              <span class="mx-2">:</span>
              <span>{{ hotel.website }}</span>
            </div>
            <div class="d-flex align-items-start mb-2 text-dark">
              <i class="fas fa-map-marked-alt fs-5"></i>
              <span class="mx-2">:</span>
              <span>
                {{ hotel.address !== "" || null ? hotel.address + "," : "" }}
                {{ hotel.city !== "" || null ? hotel.city + "," : "" }}
                {{ hotel.state !== "" || null ? hotel.state + "," : "" }}
                {{ hotel.country !== "" || null ? hotel.country + "," : "" }}
                {{ hotel.zip_code !== "" || null ? hotel.zip_code : "" }}
              </span>
            </div>
          </div>
          <div class="col-md-3" v-if="hotel.logo !== '' || null">
            <img
              :src="hotel.logo"
              alt="hotel-logo"
              class="card-hotel-logo ms-auto d-block"
              @click="generateReport()"
              v-b-popover.hover="'Click To Download'"
            />
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-md-5">
            <h5 class="text-dark">
              {{
                selectedGuest.primary_guest.first_name
                  ? selectedGuest.primary_guest.first_name
                  : ""
              }}
              {{ selectedGuest.primary_guest.last_name }}
            </h5>
            <p class="text-dark mb-0">
              {{
                selectedGuest.primary_guest.address_line_first
                  ? selectedGuest.primary_guest.address_line_first
                  : ""
              }}
              {{
                selectedGuest.primary_guest.address_line_second
                  ? selectedGuest.primary_guest.address_line_second + ", "
                  : ""
              }}
              {{
                selectedGuest.primary_guest.city
                  ? selectedGuest.primary_guest.city + ", "
                  : ""
              }}<br v-if="selectedGuest.primary_guest.city" />{{
                selectedGuest.primary_guest.state
                  ? selectedGuest.primary_guest.state + ", "
                  : ""
              }}<br v-if="selectedGuest.primary_guest.state" />{{
                selectedGuest.primary_guest.country
                  ? selectedGuest.primary_guest.country + ", "
                  : ""
              }}
              {{
                selectedGuest.primary_guest.zip_code
                  ? selectedGuest.primary_guest.zip_code
                  : ""
              }}
            </p>
          </div>
          <div class="col-md-7">
            <div class="d-flex justify-content-end">
              <div class="border-right px-3 text-center">
                <h5 class="text-dark font-size-14">Booking Ref.</h5>
                <p class="text-danger mb-0">
                  {{ selectedGuest.reference_no }}
                </p>
              </div>
              <div class="border-right px-3 text-center">
                <h5 class="text-dark font-size-14">PMS Ref.</h5>
                <p class="text-danger mb-0">
                  {{
                    selectedGuest.booking_source_reference_no
                      ? selectedGuest.booking_source_reference_no
                      : "-"
                  }}
                </p>
              </div>
              <div class="border-right px-3 text-center">
                <h5 class="text-dark font-size-14">OTA Ref.</h5>
                <p class="text-danger mb-0">
                  {{
                    selectedGuest.ota_reference_no
                      ? selectedGuest.ota_reference_no
                      : "-"
                  }}
                </p>
              </div>
              <div class="px-3 text-center">
                <h5 class="text-dark font-size-14">Source</h5>
                <p class="text-danger mb-0">
                  {{
                    selectedGuest.booking_source.name
                      ? selectedGuest.booking_source.name
                      : "-"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap">
        <div class="registration-box">
          <h6 class="mb-1">Room No.</h6>
          <span>{{
            selectedGuest.allotted_room
              ? selectedGuest.allotted_room.room_number
              : "-"
          }}</span>
        </div>
        <div class="registration-box">
          <div class="d-flex align-items-center">
            <i class="bx bx-calendar me-2 fs-4"></i>
            <div class="d-flex align-items-center">
              <div>
                <h6 class="mb-1">Check-In</h6>
                <span>{{ selectedGuest.check_in_date }}</span>
              </div>
              <div>
                <div class="total-night bg-primary bg-soft">
                  <i class="fas fa-moon text-primary"></i>
                  <span class="font-weight-semibold ms-1 text-primary">{{
                    selectedGuest.stay_night
                  }}</span>
                </div>
              </div>
              <div>
                <h6 class="mb-1">Check-Out</h6>
                <span>{{ selectedGuest.check_out_date }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="registration-box">
          <div class="d-flex align-items-center">
            <i class="bx bx-bed me-2 fs-4"></i>
            <div>
              <h6 class="mb-1">Room Type</h6>
              <span class="mw-170 text-truncate">{{
                selectedGuest.room_type.name
              }}</span>
            </div>
          </div>
        </div>
        <div class="registration-box">
          <div class="d-flex align-items-center">
            <i class="bx bx-user me-2 fs-4"></i>
            <div>
              <h6 class="mb-1">Rooms & Guests</h6>
              <span
                >{{ selectedGuest.total_room }} Room ,
                {{ selectedGuest.total_adults }} Adults</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="registration-card-detail">
        <table class="table">
          <thead>
            <tr>
              <th class="text-dark">Description</th>
              <th colspan="1"></th>
              <th class="text-end text-dark">Charge</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedGuest.transaction_box"
              :key="index"
            >
              <th>
                {{ item.description }}
              </th>
              <td colspan="1"></td>
              <td class="text-end">
                {{ item.currency ? "$" : "₹" }}{{ item.debit }}
              </td>
            </tr>

            <tr class="border-top-width">
              <th></th>
              <td>Sub Total</td>
              <td class="text-end">
                {{ selectedGuest.currency ? "$" : "₹"
                }}{{ selectedGuest.current_balance }}
              </td>
            </tr>
            <tr>
              <th></th>
              <td>Tax</td>
              <td class="text-end">
                {{ selectedGuest.currency ? "$" : "₹" }}{{ "00.00" }}
              </td>
            </tr>
            <tr>
              <th></th>
              <td>Discount</td>
              <td class="text-end">
                {{ selectedGuest.currency ? "$" : "₹" }}{{ "00.00" }}
              </td>
            </tr>
            <tr class="border-top-bottom-width">
              <th></th>
              <td class="fw-bold text-danger">GRAND TOTAL</td>
              <td class="text-end">
                {{ selectedGuest.currency ? "$" : "₹"
                }}{{ selectedGuest.current_balance }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mb-3">
        <h5 class="dotted-border text-center text-dark pb-2 mb-3">
          Payment Details
        </h5>
        <div class="d-flex">
          <div class="w-50">
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">
                Payment Type
              </h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0 text-uppercase">
                {{
                  selectedGuest.guest[0].credit_card.length !== 0
                    ? selectedGuest.guest[0].credit_card[0].card_brand
                    : "-"
                }}
              </p>
            </div>
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">Account</h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0">
                {{
                  selectedGuest.guest[0].credit_card.length !== 0
                    ? "**** " + selectedGuest.guest[0].credit_card[0].last_digit
                    : "-"
                }}
              </p>
            </div>
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">
                Account Holder
              </h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0">
                {{
                  selectedGuest.guest[0].credit_card.length !== 0
                    ? selectedGuest.guest[0].credit_card[0].card_holder_name
                    : "-"
                }}
              </p>
            </div>
          </div>
          <div>
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">Amount Paid</h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0">
                {{ selectedGuest.currency ? "$" : "₹"
                }}{{ selectedGuest.total_payment }}
              </p>
            </div>
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">
                Apporval Code
              </h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0">{{ "-" }}</p>
            </div>
            <div class="d-flex mb-2">
              <h5 class="font-size-14 min-w-130 text-dark mb-0">
                Available Auth
              </h5>
              <span class="mx-2">:</span>
              <p class="text-dark mb-0">
                {{ selectedGuest.currency ? "$" : "₹"
                }}{{ selectedGuest.current_balance }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <img
            v-if="selectedGuest.primary_guest.doc_image !== null"
            :src="selectedGuest.primary_guest.doc_image"
            alt="doc image"
            class="document-card-img rounded w-100 object-fit"
          />
          <img
            src="@/assets/images/placeholder-img.jpg"
            v-else
            class="document-card-img rounded w-100 object-fit"
          />
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-end mb-3">
            <p class="text-dark mt-40">
              By signing here digital contract, I am agreeing with all Terms &
              Condition of the hotel.
            </p>
            <div>
              <img
                v-if="selectedGuest.primary_guest.selfie_image"
                :src="selectedGuest.primary_guest.selfie_image"
                alt="selfie image"
                class="selfie-card-img rounded object-fit"
              />
              <img
                src="@/assets/images/placeholder-img.jpg"
                v-else
                class="selfie-card-img rounded object-fit"
              />
            </div>
          </div>
          <div class="dashed-border rounded">
            <img
              v-if="selectedGuest.contract_signature"
              :src="selectedGuest.contract_signature"
              alt="contract sign"
              class="img-fluid sign-img"
            />
            <img
              src="@/assets/images/signature-placeholder.png"
              v-else
              alt=""
              class="d-block mx-auto sign-img"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  data() {
    return {
      selectedGuest: null,
      hotel: null,
    };
  },
  props: {
    guestRegistrationProps: Object,
  },
  components: {
    VueHtml2pdf,
  },
  mounted() {
    if (this.guestRegistrationProps) {
      let transaction_box = [];
      if (this.guestRegistrationProps.selectedGuest !== null) {
        if (this.guestRegistrationProps.selectedGuest.folio.length !== 0) {
          this.guestRegistrationProps.selectedGuest.folio.map((folioT) => {
            const folio_transaction = folioT.folio_transaction.filter(
              (item) => item.description !== "Security Deposit"
            );
            transaction_box = [...transaction_box, ...folio_transaction];
          });
        }
      }
      this.selectedGuest = this.guestRegistrationProps.selectedGuest;
      this.selectedGuest = {
        ...this.selectedGuest,
        transaction_box,
      };
      this.hotel = this.guestRegistrationProps.hotel;
    }
  },
  methods: {
    // Method is use for generate PDF report
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped>
.registration-card-detail thead th {
  border-bottom-width: 0px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.registration-card-detail th,
.registration-card-detail td {
  padding: 7px 10px;
}
.registration-card-detail tbody th,
.registration-card-detail tbody td {
  color: #000;
  border-bottom-width: 0px;
  font-weight: 500;
}
.registration-card-detail .border-top-width td {
  border-top: 1px solid #000;
}
.registration-card-detail .border-top-bottom-width td {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.card-hotel-logo {
  max-width: 300px;
  max-height: 100px;
}

.registration-box {
  text-align: center;
  padding: 10px;
  margin: 0px 8px 8px 0px;
  background-color: #edf1f2;
}
.registration-box:last-child {
  margin: 0px 0px 8px 0px;
}

.document-card-img {
  height: 246px;
}
.selfie-card-img {
  width: 156px;
  height: 140px;
}
.sign-img {
  height: 90px;
}

.total-night {
  padding: 2px 8px;
  margin: 0px 15px;
  border-radius: 10px;
}
.total-night i {
  transform: scaleX(-1);
}
.card-hotel-logo {
  max-width: 250px;
  max-height: 80px;
}
.border-right {
  border-right: 1px solid #000;
}
.dashed-border {
  border: 1px dashed #ced4da;
}
.dotted-border {
  max-width: 200px;
  margin: 0 auto;
  border-bottom: 1px dashed #000;
}
.min-w-130 {
  min-width: 130px;
}

.mt-40 {
  margin-top: 40px;
}

.mw-170 {
  max-width: 170px;
  display: block;
}
</style>
